import { useMemo } from 'react';
import useEmployees from './useEmployees';

const useEmployeeNames = (): {
    employeeNames: Record<string, string>;
    isLoadingEmployees: boolean;
} => {
    const { employees, isLoadingEmployees } = useEmployees();

    const employeeNames = useMemo(
        () =>
            Object.fromEntries(
                employees?.map(({ id, name }) => [id, name]) ?? [],
            ) as Record<string, string>,
        [employees],
    );

    return {
        employeeNames,
        isLoadingEmployees,
    };
};

export default useEmployeeNames;
